import * as React from 'react';
import PropTypes from 'prop-types';
import {Icon, Label, Segment} from "semantic-ui-react";
import {Subbar, Title, PageHeader, SearchFilter, Sortable, Tiles, Tile} from "ah-tools";
import {translate} from "react-i18next";
import Car from '../images/car.png';
import {LOC_KFZ_LIST} from "../actions";
import {sortAsc, sortDesc, sortDefault} from "ith-sort";
import {compare, equals, compareDefault} from 'ith-compare';
import {ROUTE_KFZ_CREATE, ROUTE_KFZ_EDIT} from "../routes";
import {IMAGE_URL} from "../misc/vars";
import {IconButton} from "../extensions";

const filterOptions = [
	{key: 'name', text: 'Name', value: 'name'},
	{key: 'kfz_id', text: 'ID', value: 'kfz_id'}
];

const sortOptions = [
	{key: 'name-asc', order: 'ascending', title: 'Name aufsteigend'},
	{key: 'name-desc', order: 'descending', title: 'Name absteigend'}
];

const fromStorage = () => {
	return JSON.parse(window.localStorage.getItem(LOC_KFZ_LIST)) || {filter: '', filterOption: filterOptions[0].value, sort: 'name-asc'};
};

class KfzList extends React.Component {
	static propTypes = {
		isLoading: PropTypes.bool,
		onLoad: PropTypes.func.isRequired,
		kfz_list: PropTypes.array.isRequired,
		push: PropTypes.func.isRequired
	};
	static defaultProps = {
		isLoading: false,
		kfz_list: []
	};
	state = {
		action: fromStorage(),
		_filter: {
			filter: '',
			filterOption: filterOptions[0].key
		}
	};
	
	setFilters = (index, value) => this.setState(state => ({
		...state,
		action: {
			...state.action,
			[index]: value
		}
	}));
	
	setNormalFilters = (index, value) => this.setState(state => ({
		...state,
		_filter: {
			...state._filter, [index]: value
		}
	}));
	
	filter = () => {
		const {_filter: {filter, filterOption}} = this.state;
		if (filter.trim() === '') return () => true;
		switch(filterOption) {
			case 'name':
				return compare(filter)(kfz => kfz.name);
			case 'kfz_id':
				return equals(filter.trim())(kfz => ''+kfz.kfz_id);//kfz => ('' + kfz.kfz_id) === filter.trim();//.match(filter.trim().toLowerCase());
			default:
				return compareDefault;
		}
	};
	
	sort = () => {
		switch(this.state.action.sort) {
			case 'name-asc':
				return sortAsc(kfz => kfz.name);
				// return (a,b) => a.toLowerCase().localeCompare(b.toLowerCase());
			case 'name-desc':
				return sortDesc(kfz => kfz.name);
				// return (a,b) => b.toLowerCase().localeCompare(a.toLowerCase());
			default:
				return sortDefault;
		}
	};
	
	render = () => {
		const {isLoading, kfz_list, push} = this.props;
		const {action: filterState, _filter} = this.state;
		
		window.localStorage.setItem(LOC_KFZ_LIST, JSON.stringify(filterState));
		return (
			<Segment basic>
				<PageHeader align={Subbar.ALIGN_BETWEEN}>
					<Title loading={isLoading}>Kfz-Liste (Hersteller)</Title>
					<Subbar>
						<Sortable
							onChange={(_, key, value) => this.setFilters('sort', value)}
							value={filterState.sort}
							options={sortOptions}
						/>
						<SearchFilter
							value={_filter.filter}
							onChange={value => this.setNormalFilters('filter', value)}
							selected={_filter.filterOption}
							options={filterOptions}
							onSelect={value => this.setNormalFilters('filterOption', value)}
						/>
						<IconButton onClick={() => push(ROUTE_KFZ_CREATE)}><Icon name={'plus'} size={'large'}/></IconButton>
					</Subbar>
				</PageHeader>
				<Tiles>
					{kfz_list.filter(this.filter()).sort(this.sort()).map(({kfz_id, name, logo}) =>
						<Tile
							key={kfz_id}
							onClick={() => push(ROUTE_KFZ_EDIT.replace(':kfz_id', kfz_id))}
							style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', boxShadow: '0 0 6px #666', position: 'relative'}}>
							<img src={logo ? `${IMAGE_URL}${logo.ident}.${logo.origin_extension}?${logo.updated_at}` : Car} alt={name || 'Car-Logo'} style={{margin: 'auto'}}/>
							<strong>{name}</strong>
							<Label ribbon style={{position: 'absolute', top: 10, left: -14}}>{kfz_id}</Label>
						</Tile>
					)}
					
				</Tiles>
				{/*<pre>{JSON.stringify(filterState, null, 4)}</pre>*/}
			</Segment>
		);
	};
}

export default translate()(KfzList);


// WEBPACK FOOTER //
// ./src/components/KfzList.js